import { Component, Input, OnInit ,OnDestroy} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IonSlides, ModalController } from '@ionic/angular';
import { RequestService } from 'src/app/services/request/request.service';

import { ViewChild } from '@angular/core';


@Component({
  selector: 'app-superlative-streams',
  templateUrl: './superlative-streams.component.html',
  styleUrls: ['./superlative-streams.component.scss'],
})

export class SuperlativeStreamsComponent implements OnInit {
  private hlsLoader?: Promise<any>;

  private loadHls(): Promise<any> {
    const existingHls = (window as any).Hls;
    if (existingHls) {
      return Promise.resolve(existingHls);
    }

    if (!this.hlsLoader) {
      this.hlsLoader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
        script.async = true;
        script.onload = () => resolve((window as any).Hls);
        script.onerror = () => reject(new Error('Hls.js could not be loaded.'));
        document.head.appendChild(script);
      });
    }

    return this.hlsLoader;
  }
  @ViewChild(IonSlides) slides: IonSlides | undefined;
  currentChannel
  @Input() url: string = '';
  @Input() iptv:any;

  @Input() channels: { name: string; logo: string; url: string; gifts?: number; likes?: number; views?: number }[] = [];
  safeUrl: SafeResourceUrl = '';
  @Input() activeChannelIndex:number =0;
  show=true;
  videoUrl;
  slideOpts = {
    loop: true,
    direction: 'horizontal',
    initialSlide: 0,
    speed: 420,
   
  };

  constructor(private sanitizer: DomSanitizer,private Mctrl: ModalController,
    private request: RequestService,
    ) {}

  ngOnInit() {

    console.log('iptv', this.activeChannelIndex)
    console.log('iptv length', this.channels?.length)
    console.log('iptv ', this.iptv)
    if(!this.iptv){
    // Convert YouTube URL to embed format and add autoplay and controls parameters
    const embedUrl = this.url
      .replace('watch?v=', 'embed/')
      + '?autoplay=1&controls=0&playsinline=1';
      
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    setTimeout(() => {
      this.show = true;
    }, 9999);
          
  }else{
    setTimeout(() => {
    console.log('channels activeChannelIndex',this.channels[this.activeChannelIndex])
    console.log('channels activeChannelIndex',this.iptv)
     this.currentChannel = this.channels[this.activeChannelIndex];
     const channel = this.channels.find((channel) => channel.url === this.iptv.url);
        // Find the index of the slide
        this.currentChannel = channel;
      
        // Find the index of the currentChannel
        const slideIndex = this.channels.indexOf(this.currentChannel);
        console.log('slideIndex', slideIndex +1 );
          // Navigate to the matching slide
          this.slides.slideTo(slideIndex +1)  ;
     if (channel) {
      this.currentChannel = channel;
      this.playChannel(channel.url, channel);
     } 
  }, 1800);
  }
  }
  ngAfterViewInit(){
   

  }
  onSlideChange(event: any) {
    this.show=false;

    const slider = event.target;
    slider.getActiveIndex().then((index: number) => {
    
        this.activeChannelIndex = index;
      
       //this.channels.find((channel) => channel.url === this.iptv.url);
           const channel = this.channels[this.activeChannelIndex-1]

           if (channel) {
            this.currentChannel = channel;
            this.playChannel(channel.url, channel);
           } 
        
        
      
    })
  }
  async playChannel(url:any, channel) {

    this.request.createRequestPost('PersistentLiveStreamIPTVController', { record: channel })
    .then((final_data) => {
      if (final_data && typeof final_data === 'string') {
        try {
          final_data = JSON.parse(final_data);
          console.log('getRecordByToken ios:',final_data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
  console.log('final_data',final_data);
  let record=final_data;
     // Find the channel where the URL matches record.m3u8
     const channel = this.channels.find((channel) => channel.url === record.m3u8);

     if (channel) {
         // Update the channel object with gifts, likes, and views
         channel.gifts = record.gifts;
         channel.likes = record.likes;
         channel.views = record.views;
     } else {
         console.error('Channel not found for URL:', record.m3u8);
     }
    })
    
    const video = document.getElementById(
      `${this.currentChannel.url}`
    ) as HTMLVideoElement;
    if (!video) {
      console.error('Video element not found.');
      return;
    }
  
    // Clean up any previous Hls.js instance
    if ((window as any).hlsInstance) {
      (window as any).hlsInstance.destroy();
      (window as any).hlsInstance = null;
    }
  
    // Directly use the raw URL (no proxy)
    const directUrl = url;
  
    // iOS/Safari supports HLS natively, so it never needs to download Hls.js.
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      console.log('Using native HLS in Safari...');
      video.src = directUrl;
      this.videoUrl = directUrl;
      video.play().catch(err => console.error('Play error (native):', err));
      return;
    }

    let HlsRuntime: any;
    try {
      HlsRuntime = await this.loadHls();
    } catch (error) {
      console.error(error);
      return;
    }

    if (HlsRuntime && HlsRuntime.isSupported()) {
      console.log('Using Hls.js with M3U8 URL:', directUrl);
      const hls = new HlsRuntime();
      (window as any).hlsInstance = hls;
  
      hls.loadSource(directUrl);
      hls.attachMedia(video);
  
      hls.on(HlsRuntime.Events.MANIFEST_PARSED, () => {
        console.log('HLS manifest parsed, playing...');
        this.videoUrl = directUrl;
        video.play().catch(err => console.error('Play error:', err));
      });
  
      hls.on(HlsRuntime.Events.ERROR, (event, data) => {
        console.error('Hls.js error:', data);
        if (data.fatal) {
          switch (data.type) {
            case HlsRuntime.ErrorTypes.NETWORK_ERROR:
              // try to recover network error
              hls.startLoad();
              break;
            case HlsRuntime.ErrorTypes.MEDIA_ERROR:
              // try to recover media error
              hls.recoverMediaError();
              break;
            default:
              // cannot recover
              hls.destroy();
              break;
          }
        }
      });
    }
    else {
      console.error('No HLS support in this browser.');
    }
  }
  dismiss(){
    this.Mctrl.dismiss();
  }
  preventIframeClick() {
    const overlay = document.querySelector('.overlay') as HTMLElement;
    if (overlay) {
      overlay.style.pointerEvents = 'none'; // Disable clicks
    }
  }
  
}

